import React, { Component } from 'react';  
import { Picker, List, Toast } from 'antd-mobile/lib';
import { 
	userJob,
	getUserJob,
	provinceCity,
	getProvinceCity,
	smrzCardPerson,
	smrzPersonNumber,
	smrzAddress,
	smrzkzrAddress,
	smrzsyrAddress,
	smrzkzrBianma,
	smrzsyrBianma,
	smrzkzrYoux,
	smrzsyrYoux,
	smrzJob,
	smrzkzrJob,
	smrzsyrJob,
	smrzCareerCode,
	smrzCareerkzrCode,
	smrzCareersyrCode,
	smrzCity,
	smrzkzrCityc,
	smrzsyrCityc,
	smrzBeneficiaries,
	smrzBeneficiariesName,
	smrzBeneficontro,
	smrzBeneficontroName,
	smrzBeneficiariesType,
	smrzBeneficontroType,
	smrzBeneficiariesNo,
	smrzBeneficontroNo,
	smrzGjzz,
	smrzCardNumber,
	smrznsrcode,
	smrznJtsrcode,
	smrzBeneficontroZjyxq,
	zzhZjyxq,
	smrzBeneficiariesZjyxq,
	smrzBeneficontroZjzq,
	smrzBeneficiariesZjzq,
	smrzkzrXbcode,
	smrzsyrXbcode,
	smrzBeneficontroCsrq,
	smrzBeneficiariesCsrq,
	smrzBeneficontroKzrNo,
	smrzBeneficontroSyrNo,
	validateAgeUserCertNo,
	huiDiao,
	ZTbool
} from '../../action/investmentAction.js';
import { connect } from 'react-redux';
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import "./css/CertificationCard.css";
import ModalList from "../Modal/ModalList"
import { backgroundColor, returnDate } from "../../util"

class CertificationCard extends Component {
	state = {
		cardPerson: this.props.location.state.realName?this.props.location.state.realName:"",
		personNumber: this.props.location.state.personNo?this.props.location.state.personNo:"",
		address: this.props.smrzAddress,
		job: this.props.smrzJob,
		city: this.props.smrzCity,
		beneficiaries: this.props.smrzBeneficiaries,
		beneficiariesName: this.props.smrzBeneficiariesZjzq?this.props.smrzBeneficiariesZjzq.realName:"",
		beneficiariesType: this.props.smrzBeneficiariesType,
		beneficiariesNo: this.props.smrzBeneficiariesZjzq?this.props.smrzBeneficiariesZjzq.personNo:"",
		beneficontro: this.props.smrzBeneficontro,
		beneficontroName: this.props.smrzBeneficontroZjzq?this.props.smrzBeneficontroZjzq.realName:"",
		beneficontroType: this.props.smrzBeneficontroType,
		beneficontroNo: this.props.smrzBeneficontroZjzq?this.props.smrzBeneficontroZjzq.personNo:"",
		isImportant: this.props.smrzGjzz,
		phoneNo: this.props.location.state.phoneNo?this.props.location.state.phoneNo:"",
		enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
		careerCode: this.props.smrzCareerCode,
		annualIncome: "",
		nsrcode: this.props.smrznsrcode,
		annualIncomeV2: this.props.smrznJtsrcode,
		actualControllerValidTerm: this.props.smrzBeneficontroZjyxq?this.props.smrzBeneficontroZjyxq.actualControllerValidTerm:"",
		certValidTerm: this.props.zzhZjyxq?this.props.zzhZjyxq.certValidTerm:"",
		certValidEver: this.props.zzhZjyxq?this.props.zzhZjyxq.certValidEver:"",
		actualControllerValidEver: this.props.smrzBeneficontroZjyxq?this.props.smrzBeneficontroZjyxq.actualControllerValidEver:"",
		kzrBool: this.props.smrzBeneficontroZjzq?this.props.smrzBeneficontroZjzq.Boll:"",
		actualControllerSex: "",
		kzrXbcode:this.props.smrzkzrXbcode,
		actualControllerBirthday: this.props.smrzBeneficontroCsrq?this.props.smrzBeneficontroCsrq.actualControllerBirthday:"",
		actualControllerMobileNo: this.props.smrzBeneficontroKzrNo,
		actualControllerProvince:  this.props.smrzkzrCityc,
		actualControllerAddress: this.props.smrzkzrAddress,
		actualControllerPostcode: this.props.smrzkzrBianma,
		kzrjob: this.props.smrzkzrJob,
		careerkzrCode: this.props.smrzCareerkzrCode,
		actualControllerEmail: this.props.smrzkzrYoux,
		actualBeneficiaryValidTerm: this.props.smrzBeneficiariesZjyxq?this.props.smrzBeneficiariesZjyxq.actualBeneficiaryValidTerm:"",
		actualBeneficiaryValidEver: this.props.smrzBeneficiariesZjyxq?this.props.smrzBeneficiariesZjyxq.actualBeneficiaryValidEver:"",
		syrBool: this.props.smrzBeneficiariesZjzq?this.props.smrzBeneficiariesZjzq.Boll:"",
		actualBeneficiarySex: "",
		syrXbcode: this.props.smrzsyrXbcode,
		actualBeneficiaryBirthday: this.props.smrzBeneficiariesCsrq?this.props.smrzBeneficiariesCsrq.actualBeneficiaryBirthday:"",
		actualBeneficiaryMobileNo: this.props.smrzBeneficontroSyrNo,
		actualBeneficiaryProvince: this.props.smrzsyrCityc,
		actualBeneficiaryAddress:  this.props.smrzsyrAddress,
		actualBeneficiaryPostcode: this.props.smrzsyrBianma,
		syrjob: this.props.smrzsyrJob,
		careersyrCode: this.props.smrzCareersyrCode,
		actualBeneficiaryEmail: this.props.smrzsyrYoux,
		alertFlag: false,
		userInfo: "",
		validityVal: this.props.location.state.validity.split("-")[1]
	}

	componentDidMount() {
		console.log(this.props.location)
		this.props.dispatch(huiDiao(this.props.location.state.savePicFun?this.props.location.state.savePicFun:this.props.huiDiao))
		console.log(this.props.huiDiao)
		this.props.dispatch(validateAgeUserCertNo({certNo: this.state.personNumber}, (sec) => {
			if(sec) {
				if(sec.eighteenBelow == true){
					this.setState({
						alertFlag: true
					})
				}
			}
		}, () => {

		}));
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
		document.getElementsByTagName('title')[0].innerHTML = "实名认证";
		let { dispatch } = this.props;
		dispatch(userJob(null));
		dispatch(provinceCity(null));
		Toast.loading("正在加载");
		dispatch(getProvinceCity((data) => {
			this.setState({
				city: [data[0].provinceCode, data[0].cityList[0].cityCode]
			});
			dispatch(smrzCity([data[0].provinceCode, data[0].cityList[0].cityCode]));
			dispatch(smrzkzrCityc([data[0].provinceCode, data[0].cityList[0].cityCode]));
		}, () => {
			
		}));
		dispatch(getUserJob());
	}

	changeJob = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				job: value,
				careerCode: value[0]
			});
			dispatch(smrzCareerCode(value[0]));
			dispatch(smrzJob(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				job: [this.props.userJob[0].careerId],
				careerCode: this.props.userJob[0].careerId
			});
			dispatch(smrzCareerCode(this.props.userJob[0].careerId));
			dispatch(smrzJob([this.props.userJob[0].careerId]));
		}
	}

	changekzrJob = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				kzrjob: value,
				careerkzrCode: value[0]
			});
			dispatch(smrzCareerkzrCode(value[0]));
			dispatch(smrzkzrJob(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				kzrjob: [this.props.userJob[0].careerId],
				careerkzrCode: this.props.userJob[0].careerId
			});
			dispatch(smrzCareerkzrCode(this.props.userJob[0].careerId));
			dispatch(smrzkzrJob([this.props.userJob[0].careerId]));
		}
	}

	changesyrJob = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				syrjob: value,
				careersyrCode: value[0]
			});
			dispatch(smrzCareersyrCode(value[0]));
			dispatch(smrzsyrJob(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				syrjob: [this.props.userJob[0].careerId],
				careersyrCode: this.props.userJob[0].careerId
			});
			dispatch(smrzCareersyrCode(this.props.userJob[0].careerId));
			dispatch(smrzsyrJob([this.props.userJob[0].careerId]));
		}
	}
	
	changeNsr = (value) => {
		let { dispatch } = this.props;
		let nsr = [
			{careerId: '1', careerName: '0—10万（含）'},
			{careerId: '2', careerName: '10万—30万（含）'},
			{careerId: '3', careerName: '30万—50万（含）'},
			{careerId: '4', careerName: '50万以上'}
		]
		if(value[0]) {
			for(let i = 0; i < nsr.length; i++){
				if(value[0]==nsr[i].careerId){
					this.setState({
						annualIncome: nsr[i].careerName,
						nsrcode:[nsr[i].careerId]
					})
					dispatch(smrznsrcode([nsr[i].careerId]));
				}
			}
		}else {
			this.setState({
				annualIncome: nsr[0].careerName,
				nsrcode:[nsr[0].careerId]
			})
			dispatch(smrznsrcode([nsr[0].careerId]));
		}
	}

	changekzrXb = (value) => {
		let { dispatch } = this.props;
		let xb = [
			{careerId: '1', careerName: '男'},
			{careerId: '0', careerName: '女'},
		]
		if(value[0]) {
			for(let i = 0; i < xb.length; i++){
				if(value[0]==xb[i].careerId){
					this.setState({
						actualControllerSex: xb[i].careerName,
						kzrXbcode:[xb[i].careerId]
					})
					dispatch(smrzkzrXbcode([xb[i].careerId]));
				}
			}
		}else {
			this.setState({
				actualControllerSex: xb[0].careerName,
				kzrXbcode:[xb[0].careerId]
			})
			dispatch(smrzkzrXbcode([xb[0].careerId]));
		}
	}

	changesyrXb = (value) => {
		let { dispatch } = this.props;
		let xb = [
			{careerId: '1', careerName: '男'},
			{careerId: '0', careerName: '女'},
		]
		if(value[0]) {
			for(let i = 0; i < xb.length; i++){
				if(value[0]==xb[i].careerId){
					this.setState({
						actualBeneficiarySex: xb[i].careerName,
						syrXbcode:[xb[i].careerId]
					})
					dispatch(smrzsyrXbcode([xb[i].careerId]));
				}
			}
		}else {
			this.setState({
				actualBeneficiarySex: xb[0].careerName,
				syrXbcode:[xb[0].careerId]
			})
			dispatch(smrzsyrXbcode([xb[0].careerId]));
		}
	}

	changeCity = (value) => {
		let { dispatch } = this.props;
		this.setState({
			city: value
		});
		dispatch(smrzCity(value));
	}

	changekzrCity = (value) => {
		let { dispatch } = this.props;
		this.setState({
			actualControllerProvince: value
		});
		dispatch(smrzkzrCityc(value));
	}

	changesyrCity = (value) => {
		let { dispatch } = this.props;
		this.setState({
			actualBeneficiaryProvince: value
		});
		dispatch(smrzsyrCityc(value));
	}
	
	changeBeneficiaries = (value) => {
		let { dispatch } = this.props;
		this.setState({
			beneficiaries: value
		});
		dispatch(smrzBeneficiaries(value));
	}

	changeBeneficontro = (value) => {
		let { dispatch } = this.props;
		this.setState({
			beneficontro: value
		});
		dispatch(smrzBeneficontro(value));
	}

	changeBeneficiariesType = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				beneficiariesType: value
			});
			dispatch(smrzBeneficiariesType(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				beneficiariesType: ["身份证"]
			});
			dispatch(smrzBeneficiariesType(["身份证"]));
		}
	}

	changeBeneficontroType = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				beneficontroType: value
			});
			dispatch(smrzBeneficontroType(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				beneficontroType: ["身份证"]
			});
			dispatch(smrzBeneficontroType(["身份证"]));
		}
	}

	Zhzjyxq = (vals) =>{
		let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
		let { dispatch } = this.props;
		hashHistory.push({
			pathname: "/ChangTime",
			state: {
				route: route,
				dispatch: dispatch,
				onFun: (val)=>{
					dispatch(zzhZjyxq(val));
				},
				valu: vals
			},
			query: {
			}
		})
	}
	changeBeneficontrozjyxq = (vals) =>{
		let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
		let { dispatch } = this.props;
		hashHistory.push({
			pathname: "/ChangTime",
			state: {
				route: route,
				dispatch: dispatch,
				onFun: (val)=>{
					console.log(val)
					if(val.str=="控制人证件有效期"){
						dispatch(smrzBeneficontroZjyxq(val));
					}else if(val.str=="受益人证件有效期"){
						dispatch(smrzBeneficiariesZjyxq(val));
					}else if(val.str=="控制人出生日期"){
						dispatch(smrzBeneficontroCsrq(val));
					}else if(val.str=="受益人出生日期"){
						dispatch(smrzBeneficiariesCsrq(val));
					}
				},
				valu: vals
			},
			query: {
			}
		})
	}
	changeBeneficontrozjzq = () => {
		let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
		let { dispatch } = this.props;
		hashHistory.push({
			pathname: "/CertiUpload",
			state: {
				route: route,
				onFun: (val)=>{
					console.log(val)
					dispatch(smrzBeneficontroZjzq(val));
				},
				accountRole: 1,
				kzrId: this.props.location.state.kzrId
			},
			query: {
			}
		})
	}
	changeBeneficiarieszjzq = () => {
		let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
		let { dispatch } = this.props;
		hashHistory.push({
			pathname: "/CertiUpload",
			state: {
				route: route,
				onFun: (val)=>{
					dispatch(smrzBeneficiariesZjzq(val));
				},
				accountRole: 2,
				syrId: this.props.location.state.syrId
			},
			query: {
			}
		})
	}

	changeIsImportant = (value) => {
		let { dispatch } = this.props;
		this.setState({
			isImportant: value
		});
		dispatch(smrzGjzz(value));
	}

	goCertification = () => {
		let validitya = this.props.location.state.validity.split("-")[0]
		let validityc= ""
		if(this.props.zzhZjyxq){
			for(let i=0; i<this.props.zzhZjyxq.certValidTerm.length; i++){
				if(this.props.zzhZjyxq.certValidTerm[i]=="-"){
					validityc+="."
				}else{
					validityc+=this.props.zzhZjyxq.certValidTerm[i]
				}
			}
		}
		let validityb = this.props.zzhZjyxq?validityc:this.props.location.state.validity.split("-")[1]
		let formData = {
			mobileNo: this.props.location.state.phoneNo,
			certificateNo: this.state.personNumber,
			certificateName: this.state.cardPerson,
			isCertificateValidEver: this.state.certValidEver=="1"?1:0,
			validity: validitya+"-"+validityb,
		}
		
		console.log(formData)
		this.props.dispatch(ZTbool(formData, this, (result) => {
			if(result.validEver){
				if(result.ztValidate){
					let { dispatch } = this.props;
					let { actualBeneficiaryEmail, careersyrCode, actualBeneficiaryPostcode, actualBeneficiaryAddress, actualBeneficiaryMobileNo, careerkzrCode, phoneNo, cardPerson, personNumber, beneficiariesName, beneficiaries, beneficontroName, beneficontro, beneficiariesType, beneficontroType, beneficiariesNo, beneficontroNo, isImportant, address, job, city, careerCode, nsrcode, annualIncomeV2, annualIncome, actualControllerValidTerm, actualControllerValidEver, kzrXbcode, actualBeneficiaryValidTerm, actualBeneficiaryValidEver, syrXbcode, actualControllerBirthday, actualBeneficiaryBirthday, actualControllerMobileNo, actualControllerProvince, actualControllerAddress, actualControllerPostcode, actualControllerEmail, actualBeneficiaryProvince } = this.state;
					let regName = /^([\u4e00-\u9fa5]){2,7}$/;
					let regNo =  /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
					let regAddress = /[\u4e00-\u9fa5]+/i;
					let regSjh = /^[1][3-9][0-9]{9}$/;
					let regYzbm = /^[0-9]\d{5}(?!\d)$/;
					let regDzyx =  /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if(!regName.test(cardPerson)) {
						Toast.info( "请输入正确格式的持卡人", 2);
						return ;
					}
					if(!regNo.test(personNumber)) {
						Toast.info( "请输入正确格式的身份证号", 2);
						return ;
					}
					if(cLength(address) < 6) {
						Toast.info( "详细地址不能少于6个汉字", 2);
						return ;
					}
					if(!careerCode) {
						Toast.info( "请选择职业", 2);
						return ;
					}
					if(nsrcode[0]=="4"){
						if(Number(annualIncomeV2)<=50 || this.state.annualIncomeV2.length>12) {
							Toast.info( "请输入12位以内的整数并且大于50（万）", 2);
							return ;
						}
					}
					if(beneficontro == "他人") {
						if(!regName.test(beneficontroName)) {
							Toast.info( "请输入正确格式的控制人姓名", 2);
							return ;
						}
						if(!beneficontroType) {
							Toast.info( "请选择控制人证件类型", 2);
							return ;
						}
						if(!beneficontroNo) {
							Toast.info( "请输入控制人证件号", 2);
							return ;
						}
						if(beneficontroType == '身份证' && !regNo.test(beneficontroNo)){
							Toast.info('请输入正确格式的控制人身份证号', 2);
							return;
						}
						if(cLength(actualControllerAddress) < 6) {
							Toast.info( "控制人详细地址不能少于6个汉字", 2);
							return ;
						}
						if(!regSjh.test(actualControllerMobileNo)){
							Toast.info('请输入正确格式的控制人手机号', 2);
							return;
						}
						if(!regYzbm.test(actualControllerPostcode)){
							Toast.info('请输入正确格式的控制人邮政编码', 2);
							return;
						}
						if(!regDzyx.test(actualControllerEmail)){
							Toast.info('请输入正确格式的控制人电子邮箱', 2);
							return;
						}
					}
					if(beneficiaries == "他人") {
						if(!regName.test(beneficiariesName)) {
							Toast.info( "请输入正确格式的受益人姓名", 2);
							return ;
						}
						if(!beneficiariesType) {
							Toast.info( "请选择受益人证件类型", 2);
							return ;
						}
						if(!beneficiariesNo) {
							Toast.info( "请输入受益人证件号", 2);
							return ;
						}
						if(beneficiariesType == '身份证' && !regNo.test(beneficiariesNo)){
							Toast.info('请输入正确格式的受益人身份证号', 2);
							return;
						}
						if(cLength(actualBeneficiaryAddress) < 6) {
							Toast.info( "受益人详细地址不能少于6个汉字", 2);
							return ;
						}
						if(!regSjh.test(actualBeneficiaryMobileNo)){
							Toast.info('请输入正确格式的受益人手机号', 2);
							return;
						}
						if(!regYzbm.test(actualBeneficiaryPostcode)){
							Toast.info('请输入正确格式的受益人邮政编码', 2);
							return;
						}
						if(!regDzyx.test(actualBeneficiaryEmail)){
							Toast.info('请输入正确格式的受益人电子邮箱', 2);
							return;
						}
					}
					let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
					let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
					let theNo = {
						"身份证": "0",
						"护照": "1",
						"户口本": "5",
						"警官证": "a",
						"文职证": "b",
						"港澳居民来往内地通行证(原回乡证)": "4",
						"台胞证": "A"
					}
					hashHistory.push({
						pathname: "/certificationCardAgain",
						state: {
							name: cardPerson,
							certNo: personNumber.toUpperCase(),
							certType: 0,
							address: address,
							careerCode: careerCode,
							cityCode: city[1],
							provinceCode: city[0],
							actualBeneficiary: beneficiaries == "本人" ? cardPerson : beneficiariesName,
							actualController: beneficontro == "本人" ? cardPerson : beneficontroName,
							actualBeneficiaryCertType: "0",
							actualBeneficiaryCertNo: beneficiaries == "本人"?personNumber:beneficiariesNo,
							actualControllerCertType: "0",
							actualControllerCertNo:  beneficontro == "本人"?personNumber:beneficontroNo,
							officialsOrRelatives: isImportant == "是" ? true : false, 
							phoneNo: phoneNo,
							callback: callback,
							route: route,
							enterType:this.state.enterType,
							annualIncomeV2:annualIncomeV2?(annualIncomeV2*10000).toString():"",
							annualIncome:nsrcode[0]?nsrcode[0]:"",
							actualControllerBirthday: beneficontro == "本人"?"":actualControllerBirthday,
							actualControllerValidTerm: beneficontro == "本人"?"":actualControllerValidTerm,
							actualControllerValidEver: beneficontro == "本人"?"":actualControllerValidEver,
							actualControllerSex: beneficontro == "本人"?"":kzrXbcode[0],
							actualControllerMobileNo: beneficontro == "本人"?"":actualControllerMobileNo,
							actualControllerCity: beneficontro == "本人"?"":actualControllerProvince[1],
							actualControllerProvince: beneficontro == "本人"?"":actualControllerProvince[0],
							actualControllerProfession: beneficontro == "本人"?"":careerkzrCode,
							actualControllerAddress: beneficontro == "本人"?"":actualControllerAddress,
							actualControllerPostcode: beneficontro == "本人"?"":actualControllerPostcode,
							actualControllerEmail: beneficontro == "本人"?"":actualControllerEmail,
							actualBeneficiaryValidTerm: beneficiaries == "本人"?"":actualBeneficiaryValidTerm,
							actualBeneficiaryValidEver: beneficiaries == "本人"?"":actualBeneficiaryValidEver,
							actualBeneficiarySex: beneficiaries == "本人"?"":syrXbcode[0],
							actualBeneficiaryBirthday: beneficiaries == "本人"?"":actualBeneficiaryBirthday,
							actualBeneficiaryMobileNo: beneficiaries == "本人"?"":actualBeneficiaryMobileNo,
							actualBeneficiaryCity: beneficiaries == "本人"?"":actualBeneficiaryProvince[1],
							actualBeneficiaryProvince: beneficiaries == "本人"?"":actualBeneficiaryProvince[0],
							actualBeneficiaryAddress: beneficiaries == "本人"?"":actualBeneficiaryAddress,
							actualBeneficiaryPostcode: beneficiaries == "本人"?"":actualBeneficiaryPostcode,
							actualBeneficiaryProfession: beneficiaries == "本人"?"":careersyrCode,
							actualBeneficiaryEmail: beneficiaries == "本人"?"":actualBeneficiaryEmail,
							savePicFun: this.props.huiDiao,
							conversationId: this.props.location.state.conversationId?this.props.location.state.conversationId:"",
							certValidTerm: this.state.certValidTerm,
							certValidEver: this.state.certValidEver=="1"?1:0,
							certLifeTime: this.state.certValidTerm,
						},
						query: {enterType:this.state.enterType,
							activityId:this.props.location.query.activityId
						}
					})
					dispatch(smrzCardNumber(""));
					Toast.hide();
				}else{
					Toast.info( "证通鉴权不通过", 2);
					return;
				}
			}else{
				Toast.info( "证件有效期按相关规定不能选择长期有效", 2);
				return;
			}
		}))
	}

	changeCardPerson = (event) => {
		let { dispatch } = this.props;
		this.setState({
			cardPerson :event.target.value
		})
		dispatch(smrzCardPerson(event.target.value));
	}

	changeBeneficiariesName = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficiariesName: event.target.value
		});
		dispatch(smrzBeneficiariesName(event.target.value));
	}	

	changeBeneficontroName = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficontroName: event.target.value
		});
		dispatch(smrzBeneficontroName(event.target.value));
	}	

	changeBeneficiariesNo = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficiariesNo: event.target.value
		});
		dispatch(smrzBeneficiariesNo(event.target.value));
	}	

	changeBeneficontroNo = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficontroNo: event.target.value
		});
		dispatch(smrzBeneficontroNo(event.target.value));
	}	

	changeBeneficontroKzrNo = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualControllerMobileNo: event.target.value
		});
		dispatch(smrzBeneficontroKzrNo(event.target.value));
	}

	changeBeneficontroSyrNo = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualBeneficiaryMobileNo: event.target.value
		});
		dispatch(smrzBeneficontroSyrNo(event.target.value));
	}	
	
	changePersonNumber = (event) => {
		let { dispatch } = this.props;
		this.setState({
			personNumber :event.target.value
		})
		dispatch(smrzPersonNumber(event.target.value));
	}
	changeAddress = (event) => {
		let { dispatch } = this.props;
		this.setState({
			address :event.target.value
		})
		dispatch(smrzAddress(event.target.value));
	}
	changekzrAddress = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualControllerAddress :event.target.value
		})
		dispatch(smrzkzrAddress(event.target.value));
	}
	changesyrAddress = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualBeneficiaryAddress :event.target.value
		})
		dispatch(smrzsyrAddress(event.target.value));
	}
	changekzrBianm = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualControllerPostcode :event.target.value
		})
		dispatch(smrzkzrBianma(event.target.value));
	}
	changesyrBianm = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualBeneficiaryPostcode :event.target.value
		})
		dispatch(smrzsyrBianma(event.target.value));
	}
	changekzrYoux = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualControllerEmail :event.target.value
		})
		dispatch(smrzkzrYoux(event.target.value));
	}
	changesyrYoux = (event) => {
		let { dispatch } = this.props;
		this.setState({
			actualBeneficiaryEmail :event.target.value
		})
		dispatch(smrzsyrYoux(event.target.value));
	}
	changeNsrJuti = (event) => {
		let { dispatch } = this.props;
		this.setState({
			annualIncomeV2 :event.target.value
		})
		dispatch(smrznJtsrcode(event.target.value));
	}
	goBack = () => {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
		hashHistory.goBack();
	}
	componentWillUnmount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
	}
	closeMoadl = ()=>{
		hashHistory.goBack();
		this.setState({
			alertFlag:false
		})
	}
	render() {
		let { actualBeneficiaryEmail, syrjob, actualBeneficiaryPostcode, actualBeneficiaryAddress, actualBeneficiaryProvince, syrBool, actualControllerEmail, kzrjob, actualControllerPostcode, actualControllerAddress, actualControllerProvince, cardPerson, personNumber, city, address, job, downUpListShow, beneficiariesName, beneficiaries, beneficontroName, beneficontro, beneficiariesType, beneficontroType, beneficiariesNo, beneficontroNo, isImportant, downListFlag, annualIncome, nsrcode, annualIncomeV2, actualControllerValidTerm, kzrBool, kzrXbcode, actualControllerBirthday, actualControllerMobileNo, actualBeneficiaryValidTerm, syrXbcode, actualBeneficiaryBirthday, actualBeneficiaryMobileNo} = this.state;
		let nsrArr = [];
		let xbArr = [];
		let btnArr = [];
		let jobArr = [];
		let cityArr = [];
		let nsr = [
			{careerId: '1', careerName: '0—10万（含）'},
			{careerId: '2', careerName: '10万—30万（含）'},
			{careerId: '3', careerName: '30万—50万（含）'},
			{careerId: '4', careerName: '50万以上'}
		]
		let xb = [
			{careerId: '1', careerName: '男'},
			{careerId: '0', careerName: '女'},
		]
		for(let i = 0; i < nsr.length; i++) {
			nsrArr.push({label: nsr[i].careerName, value: nsr[i].careerId});
		}
		for(let i = 0; i < xb.length; i++) {
			xbArr.push({label: xb[i].careerName, value: xb[i].careerId});
		}
		let { provinceCity, userJob } = this.props;
		if(userJob != null) {
			for(let i = 0; i < userJob.length; i++) {
				jobArr.push({label: userJob[i].careerName, value: userJob[i].careerId});
			}
		}
		if(provinceCity != null) {
			for(let i = 0; i < provinceCity.length; i++) {
				let obj = {};
				let obj2 = [];
				obj.label = provinceCity[i].provinceName;
				obj.value = provinceCity[i].provinceCode;
				for(let k = 0; k < provinceCity[i].cityList.length; k++) {
					obj2.push({
						label: provinceCity[i].cityList[k].cityName,
						value: provinceCity[i].cityList[k].cityCode
					});
				}
				obj.children = obj2;
				cityArr.push(obj);
			}
		}
		let beneficiariesArr = [{value: "本人", label: "本人"}, {value: "他人", label: "他人"}];
		let beneficontroArr = [{value: "本人", label: "本人"}, {value: "他人", label: "他人"}];
		let beneficiariesTypeArr = [{value: "身份证", label: "身份证"}, ];
		let beneficontroTypeArr = [{value: "身份证", label: "身份证"}, ];
		let gjzzArr = [{value: "是", label: "是"}, {value: "否", label: "否"}];
		if(personNumber && cardPerson && job && city && address && beneficontro == "本人" && beneficiaries == "本人" && isImportant && nsrcode[0]) {
			if(nsrcode[0]!="4") {
				btnArr.push(
					<div 
					className="smrz-first-okbtn"
					key={0}
					onClick={this.goCertification}
					>
						<div>下一步</div>
					</div>
				);
			}else {
				if(annualIncomeV2[0]) {
					btnArr.push(
						<div 
						className="smrz-first-okbtn"
						key={0}
						onClick={this.goCertification}
						>
							<div>下一步</div>
						</div>
					);
				}else{
					btnArr.push(
						<div 
						className="smrz-first-unokbtn"
						key={0}
						>
							<div>下一步</div>
						</div>
					);
				}
			}
		}else if(personNumber && cardPerson && job && city && address && beneficontro == "他人" && beneficiaries == "本人" && isImportant) {
			if(beneficontroName && beneficontroType && beneficontroNo && actualControllerValidTerm && kzrBool && kzrXbcode && actualControllerMobileNo && actualControllerProvince && actualControllerAddress && actualControllerPostcode && kzrjob && actualControllerEmail && actualControllerBirthday) {
				btnArr.push(
					<div 
					className="smrz-first-okbtn"
					key={0}
					onClick={this.goCertification}
					>
						<div>下一步</div>
					</div>
				);
			}else {
				btnArr.push(
					<div 
					className="smrz-first-unokbtn"
					key={0}
					>
						<div>下一步</div>
					</div>
				);
			}
		}else if(personNumber && cardPerson && job && city && address && beneficiaries == "他人" && beneficontro == "本人" && isImportant) {
			if(beneficiariesName && beneficiariesType && beneficiariesNo && actualBeneficiaryValidTerm && syrBool && syrXbcode && actualBeneficiaryMobileNo && actualBeneficiaryProvince && actualBeneficiaryAddress && actualBeneficiaryPostcode && syrjob && actualBeneficiaryEmail && actualBeneficiaryBirthday) {
				btnArr.push(
					<div 
					className="smrz-first-okbtn"
					key={0}
					onClick={this.goCertification}
					>
						<div>下一步</div>
					</div>
				);
			}else {
				btnArr.push(
					<div 
					className="smrz-first-unokbtn"
					key={0}
					>
						<div>下一步</div>
					</div>
				);
			}
		}else if(personNumber && cardPerson && job && city && address && beneficiaries == "他人" && beneficontro == "他人" && isImportant) {
			if(beneficiariesName &&  beneficontroName && beneficiariesType && beneficontroType && beneficiariesNo && beneficontroNo&& actualControllerValidTerm && kzrBool && kzrXbcode && actualControllerMobileNo && actualControllerProvince && actualControllerAddress && actualControllerPostcode && kzrjob && actualControllerEmail && actualBeneficiaryValidTerm && syrBool && syrXbcode && actualBeneficiaryMobileNo && actualBeneficiaryProvince && actualBeneficiaryAddress && actualBeneficiaryPostcode && syrjob && actualBeneficiaryEmail && actualControllerBirthday && actualBeneficiaryBirthday) {
				btnArr.push(
					<div 
					className="smrz-first-okbtn"
					key={0}
					onClick={this.goCertification}
					>
						<div>下一步</div>
					</div>
				);
			}else {
				btnArr.push(
					<div 
					className="smrz-first-unokbtn"
					key={0}
					>
						<div>下一步</div>
					</div>
				);
			}
		}else {
			btnArr.push(
				<div 
				className="smrz-first-unokbtn"
				key={0}
				>
					<div>下一步</div>
				</div>
			);
		}
		return (
			<div className="mainBox"> 
		        <NavigatorMain>
		          <div className="boxHeader">
		            <div>
		              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
		            </div>
		            <div>
		              <span>实名认证</span>
		            </div>
		            <div>
		              
		            </div>
		          </div>
		        </NavigatorMain> 
		        <div className="boxContent">
					<div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
						<div style={{fontSize: "13px", color: "#5b6370"}}>根据证监会销售适当性要求，请如实填写个人信息，以便于为您提供更好的安全保障</div>
					</div>
					<div style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<span style={{
							color: "#5b6370",
							fontSize: "13px",
							width:"40%",
							display: "block"
						}}>
							持卡人
						</span>
						<input autocomplete="off"
						style={{
							width: "60%",
							fontSize: "13px",
							color: "#3a3e47",
							textAlign: 'right'
						}}
						value={cardPerson}
						onChange={this.changeCardPerson}
						placeholder="请输入持卡人姓名"
						/>
					</div>
					<div style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<span style={{
							color: "#5b6370",
							fontSize: "13px",
							width:"40%",
							display: "block"
						}}>
							身份证号
						</span>
						<input autocomplete="off"
						disabled="disabled"
						style={{
							width: "60%",
							fontSize: "13px",
							color: "#3a3e47",
							textAlign: 'right',
							backgroundColor: "#fff"
						}}
						value={personNumber}
						onChange={this.changePersonNumber}
						placeholder="请输入身份证号"
						/>
					</div>
					<div className={"pickerBox"} style={{
						display: "-webkit-flex",
						height: 45,
						backgroundColor: "#fff",
						paddingLeft: 13,
						paddingRight: 13,
						WebkitAlignItems: "center",
						WebkitFlexDirection: "row",
						borderBottom: "1px solid rgb(235, 238, 240)",
						color: "#5b6370",
					}}>
						<div style={{display:"flex",color: "#5b6370",fontSize:"13px",alignItems:"center"}} onClick={()=>{this.Zhzjyxq("主账户证件有效期")}}>
							<div style={{flex:1}}>证件有效期</div>
							<div style={{width:150,textAlign:"right"}}>{this.state.certValidEver=="1"?"长期有效":this.state.certValidTerm}</div>
							<List.Item arrow="horizontal"></List.Item>
						</div>
					</div>
					{/* <div className={actualBeneficiaryValidTerm ? "pickerBox" : "pickerBox pickerBox6"} style={{
						display: "-webkit-flex",
						height: 45,
						backgroundColor: "#fff",
						paddingLeft: 13,
						paddingRight: 13,
						WebkitAlignItems: "center",
						WebkitFlexDirection: "row",
						borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<div style={{display:"flex",fontSize:"13px",alignItems:"center"}}>
							<div style={{flex:1,color: "#5b6370"}}>证件有效期</div>
							<div style={{width:150,textAlign:"right",color: "#3a3e47"}}>{this.props.location.state.certificateValidEver?"长期有效":returnDate(this.props.location.state.certificateValidTerm)}</div>
						</div>
					</div> */}
					<div className={job[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={job} title="职业列表" data={jobArr} extra="请选择职业" onChange={this.changeJob} cols={1} className="forss">
		                  <List.Item arrow="horizontal">职业</List.Item>
		                </Picker>
					</div>
					<div className="pickerBox" style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={city} title="城市列表" data={cityArr} onChange={this.changeCity} cols={2} className="forss">
		                  <List.Item arrow="horizontal">所在城市</List.Item>
		                </Picker>
					</div>
					<div style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<span style={{
							color: "#5b6370",
							fontSize: "13px",
							width:"40%",
							display: "block"
						}}>
							详细地址
						</span>
						<input autocomplete="off"
						style={{
							width: "60%",
							fontSize: "13px",
							color: "#3a3e47",
							textAlign: 'right'
						}}
						value={address}
						onChange={this.changeAddress}
						placeholder="请输入详细地址"
						/>
					</div>
					<div className={nsrcode[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={nsrcode} title="年收入列表" data={nsrArr} extra="请选择年收入" onChange={this.changeNsr} cols={1} className="forss">
		                  <List.Item arrow="horizontal">年收入</List.Item>
		                </Picker>
					</div>
					{
						nsrcode=="4"?
						<div style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								具体年收入
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={annualIncomeV2}
							onChange={this.changeNsrJuti}
							placeholder="请输入具体年收入"
							/>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								display: "block"
							}}>
								（万）
							</span>
						</div>:null
					}
					<div className="pickerBox" style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={beneficontro} title="账户实际控制人" data={beneficontroArr} onChange={this.changeBeneficontro} cols={1} className="forss">
		                  <List.Item arrow="horizontal">账户实际控制人</List.Item>
		                </Picker>
					</div>
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								姓名
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficontroName}
							onChange={this.changeBeneficontroName}
							placeholder="请输入姓名"
							/>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div className={beneficontroType[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={beneficontroType} title="证件类型" extra="请选择证件类型" data={beneficontroTypeArr} onChange={this.changeBeneficontroType} cols={1} className="forss">
			                  <List.Item arrow="horizontal">证件类型</List.Item>
			                </Picker>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								证件号
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficontroNo}
							onChange={this.changeBeneficontroNo}
							placeholder="请输入证件号"
							/>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div className={actualControllerValidTerm ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
							color: "#5b6370",
						}}>
							<div style={{display:"flex",color: "#5b6370",fontSize:"13px",alignItems:"center"}} onClick={()=>{this.changeBeneficontrozjyxq("控制人证件有效期")}}>
								<div style={{flex:1}}>证件有效期</div>
								<div style={{width:150,textAlign:"right"}}>{actualControllerValidTerm?actualControllerValidTerm:"请选择证件有效期"}</div>
								<List.Item arrow="horizontal"></List.Item>
							</div>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						beneficontroType[0]?
						<div className={kzrBool ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
							color: "#5b6370",
						}}>
							<div style={{display:"flex",color: "#5b6370",fontSize:"13px",alignItems:"center"}} onClick={this.changeBeneficontrozjzq}>
								<div style={{flex:1}}>证件照片</div>
								<div style={{width:150,textAlign:"right"}}>{this.state.kzrBool?"已上传":"请选择证件照片"}</div>
								<List.Item arrow="horizontal"></List.Item>
							</div>
						</div>
						:null
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div className={kzrXbcode ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={kzrXbcode} title="性别列表" data={xbArr} extra="请选择性别" onChange={this.changekzrXb} cols={1} className="forss">
							  <List.Item arrow="horizontal">性别</List.Item>
							</Picker>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div className={actualControllerBirthday ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
							color: "#5b6370",
						}}>
							<div style={{display:"flex",color: "#5b6370",fontSize:"13px",alignItems:"center"}} onClick={()=>{this.changeBeneficontrozjyxq("控制人出生日期")}}>
								<div style={{flex:1}}>出生日期</div>
								<div style={{width:150,textAlign:"right"}}>{actualControllerBirthday?actualControllerBirthday:"请选择出生日期"}</div>
								<List.Item arrow="horizontal"></List.Item>
							</div>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								手机号
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualControllerMobileNo}
							onChange={this.changeBeneficontroKzrNo}
							placeholder="请输入手机号"
							/>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div className="pickerBox" style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={actualControllerProvince} title="城市列表" data={cityArr} onChange={this.changekzrCity} cols={2} className="forss">
							  <List.Item arrow="horizontal">所在城市</List.Item>
							</Picker>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								详细地址
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualControllerAddress}
							onChange={this.changekzrAddress}
							placeholder="请输入详细地址"
							/>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								邮政编码
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualControllerPostcode}
							onChange={this.changekzrBianm}
							placeholder="请输入邮政编码"
							/>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div className={kzrjob[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={kzrjob} title="职业列表" data={jobArr} extra="请选择职业" onChange={this.changekzrJob} cols={1} className="forss">
							  <List.Item arrow="horizontal">职业</List.Item>
							</Picker>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								电子邮箱
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualControllerEmail}
							onChange={this.changekzrYoux}
							placeholder="请输入电子邮箱"
							/>
						</div>
					}
					<div className="pickerBox" style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={beneficiaries} title="账户实际控制人" data={beneficiariesArr} onChange={this.changeBeneficiaries} cols={1} className="forss">
		                  <List.Item arrow="horizontal">账户实际受益人</List.Item>
		                </Picker>
					</div>
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								姓名
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficiariesName}
							onChange={this.changeBeneficiariesName}
							placeholder="请输入姓名"
							/>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div className={beneficiariesType[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={beneficiariesType} title="证件类型" extra="请选择证件类型" data={beneficiariesTypeArr} onChange={this.changeBeneficiariesType} cols={1} className="forss">
			                  <List.Item arrow="horizontal">证件类型</List.Item>
			                </Picker>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								证件号
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficiariesNo}
							onChange={this.changeBeneficiariesNo}
							placeholder="请输入证件号"
							/>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div className={actualBeneficiaryValidTerm ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
							color: "#5b6370",
						}}>
							<div style={{display:"flex",color: "#5b6370",fontSize:"13px",alignItems:"center"}} onClick={()=>{this.changeBeneficontrozjyxq("受益人证件有效期")}}>
								<div style={{flex:1}}>证件有效期</div>
								<div style={{width:150,textAlign:"right"}}>{actualBeneficiaryValidTerm?actualBeneficiaryValidTerm:"请选择证件有效期"}</div>
								<List.Item arrow="horizontal"></List.Item>
							</div>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						beneficiariesType[0]?
						<div className={syrBool ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
							color: "#5b6370",
						}}>
							<div style={{display:"flex",color: "#5b6370",fontSize:"13px",alignItems:"center"}} onClick={this.changeBeneficiarieszjzq}>
								<div style={{flex:1}}>证件照片</div>
								<div style={{width:150,textAlign:"right"}}>{this.state.syrBool?"已上传":"请选择证件照片"}</div>
								<List.Item arrow="horizontal"></List.Item>
							</div>
						</div>
						:null
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div className={syrXbcode ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={syrXbcode} title="性别列表" data={xbArr} extra="请选择性别" onChange={this.changesyrXb} cols={1} className="forss">
							  <List.Item arrow="horizontal">性别</List.Item>
							</Picker>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div className={actualBeneficiaryBirthday ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
							color: "#5b6370",
						}}>
							<div style={{display:"flex",color: "#5b6370",fontSize:"13px",alignItems:"center"}} onClick={()=>{this.changeBeneficontrozjyxq("受益人出生日期")}}>
								<div style={{flex:1}}>出生日期</div>
								<div style={{width:150,textAlign:"right"}}>{actualBeneficiaryBirthday?actualBeneficiaryBirthday:"请选择出生日期"}</div>
								<List.Item arrow="horizontal"></List.Item>
							</div>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								手机号
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualBeneficiaryMobileNo}
							onChange={this.changeBeneficontroSyrNo}
							placeholder="请输入手机号"
							/>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div className="pickerBox" style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={actualBeneficiaryProvince} title="城市列表" data={cityArr} onChange={this.changesyrCity} cols={2} className="forss">
							  <List.Item arrow="horizontal">所在城市</List.Item>
							</Picker>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								详细地址
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualBeneficiaryAddress}
							onChange={this.changesyrAddress}
							placeholder="请输入详细地址"
							/>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								邮政编码
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualBeneficiaryPostcode}
							onChange={this.changesyrBianm}
							placeholder="请输入邮政编码"
							/>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div className={syrjob[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={syrjob} title="职业列表" data={jobArr} extra="请选择职业" onChange={this.changesyrJob} cols={1} className="forss">
							  <List.Item arrow="horizontal">职业</List.Item>
							</Picker>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
							backgroundColor: "#fff",
							paddingLeft: 13,
							paddingRight: 13,
							WebkitAlignItems: "center",
							WebkitFlexDirection: "row",
							borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								电子邮箱
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={actualBeneficiaryEmail}
							onChange={this.changesyrYoux}
							placeholder="请输入电子邮箱"
							/>
						</div>
					}
					<div className="pickerBox pickerBoxTs" style={{
						display: "-webkit-flex",
						height: "auto",
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={isImportant} title="请选择是或否" data={gjzzArr} onChange={this.changeIsImportant} cols={1} className="forss">
		                  <List.Item arrow="horizontal">实际受益人为政要、国际组织高级管理人员或其亲属、关系密切的人</List.Item>
		                </Picker>
					</div>
					{
						btnArr
					}
				</div>
				<ModalList flag={this.state.alertFlag} btnRight={"确认"} btnRightFun={this.closeMoadl} content={"线上交易仅支持18周岁以上的用户开户，如果未满18周岁，请联系线下网点进行开户。"} title={"温馨提示"} />
			</div>
		)
	}
}

function mapStateToProps(state,ownProps) {
  return {
    userJob: state.userJob,
    provinceCity: state.provinceCity,
    smrzCardPerson: state.smrzCardPerson,
    smrzPersonNumber: state.smrzPersonNumber,
    smrzAddress: state.smrzAddress,
    smrzkzrAddress: state.smrzkzrAddress,
    smrzsyrAddress: state.smrzsyrAddress,
    smrzkzrBianma: state.smrzkzrBianma,
    smrzsyrBianma: state.smrzsyrBianma,
    smrzkzrYoux: state.smrzkzrYoux,
    smrzsyrYoux: state.smrzsyrYoux,
    smrzJob: state.smrzJob,
    smrzkzrJob: state.smrzkzrJob,
    smrzsyrJob: state.smrzsyrJob,
    smrzCareerCode: state.smrzCareerCode,
    smrzCareerkzrCode: state.smrzCareerkzrCode,
    smrzCareersyrCode: state.smrzCareersyrCode,
    smrznJtsrcode: state.smrznJtsrcode,
    smrznsrcode: state.smrznsrcode,
    smrzCity: state.smrzCity,
    smrzkzrCityc: state.smrzkzrCityc,
    smrzsyrCityc: state.smrzsyrCityc,
    smrzBeneficiaries: state.smrzBeneficiaries,
	smrzBeneficiariesName: state.smrzBeneficiariesName,
	smrzBeneficiariesType: state.smrzBeneficiariesType,
	smrzBeneficiariesNo: state.smrzBeneficiariesNo,
	smrzBeneficontro: state.smrzBeneficontro,
	smrzBeneficontroName: state.smrzBeneficontroName,
	smrzBeneficontroType: state.smrzBeneficontroType,
	smrzBeneficontroNo: state.smrzBeneficontroNo,
	smrzGjzz: state.smrzGjzz,
    userMobileNo: state.userMobileNo,
    smrzBeneficontroZjyxq: state.smrzBeneficontroZjyxq,
    zzhZjyxq: state.zzhZjyxq,
    smrzBeneficiariesZjyxq: state.smrzBeneficiariesZjyxq,
    smrzBeneficontroZjzq: state.smrzBeneficontroZjzq,
    smrzBeneficiariesZjzq: state.smrzBeneficiariesZjzq,
    smrzkzrXbcode: state.smrzkzrXbcode,
    smrzsyrXbcode: state.smrzsyrXbcode,
    smrzBeneficontroCsrq: state.smrzBeneficontroCsrq,
    smrzBeneficiariesCsrq: state.smrzBeneficiariesCsrq,
    smrzBeneficontroKzrNo: state.smrzBeneficontroKzrNo,
    smrzBeneficontroSyrNo: state.smrzBeneficontroSyrNo,
    huiDiao: state.huiDiao,
  }
}

function cLength(str){
  var reg = /[^\u4E00-\u9FA5\uf900-\ufa2d]/g;
  //匹配非中文的正则表达式
  var temp = str.replace(reg,'');
  return temp.length;
}


export default connect(mapStateToProps)(CertificationCard);


// WEBPACK FOOTER //
// ./src/components/recommend/CertificationCard.js